
export const groupOptionFormatterCallback = (data, groupFormat) => {
  const groupOptions = []
  _.forEach(data, group => _.forEach(group.data, option => {
    const objectFormat = groupFormat[group.type]
    const {groupCode, optionsMap} = objectFormat
    const {value = '', label = '', fixed = '', canSelect = '', ...restProps} = optionsMap
    const valueEval = _.get(option, value)
    const labelEval = _.get(option, label)
    const fixedEval = _.get(option, fixed)
    const canSelectEval = _.get(option, canSelect)
    const restPropsEval = {}
    _.forEach(restProps, (col, index) => {
      restPropsEval[index] = option[col]
    })
    groupOptions.push({
      groupCode: group.type,
      groupLabel: group.title,
      value: valueEval ? `${groupCode}_${valueEval}` : '',
      label: labelEval ?? '',
      fixed: fixedEval ?? false,
      canSelect: canSelectEval ?? true,
      ...restPropsEval
    })
  }))
  return groupOptions
}
